import '../styles/main.scss';
import Sliders from './modules/Sliders';
import Navbar from './modules/Navbar';
import Tabs from './modules/Tabs';
import Search from './modules/Search';
import Menu from './modules/Menu';
import Anchor from './modules/Anchor';
import LazyLoad from './modules/LazyLoad';

document.addEventListener('DOMContentLoaded', () => {
  new Navbar({
    selector: '.navpanel',
    fixedClass: 'is-fixed',
    offset: 700
  });

  new Navbar({
    selector: '.nav-fixed',
    fixedClass: 'is-visible',
    offset: 1000
  });

  new Search({
    searchButton: '.searchform__submit',
    stayYear: 'select[name="stayYear"]',
    stayMonth: 'select[name="stayMonth"]',
    stayDay: 'select[name="stayDay"]',
    numDays: 'select[name="dayNum"]',
    numPeople: 'select[name="peopleNum"]',
    numRooms: 'select[name="roomNum"]',
  });

  new Menu();

  new Anchor({
    trigger: '.footer__button-up a',
    position: 'top'
  });
});

window.onload = () => {
  Sliders.mainSlider();
}
